<template>
  <div>
    <ValidationObserver ref="qualificationDetailsForm">
      <v-row>
        <v-col class="col-md-7 col-12 input-item mt-2">
          <ValidationProvider v-slot="{ errors }" rules="required">
            <v-text-field
              v-model="qualification.qualificationSubject"
              :error-messages="getErrorMessages(errors)"
              label="Subject"
            />
          </ValidationProvider>
        </v-col>
        <v-col class="col-md-5 col-12 input-item mt-2">
          <ValidationProvider v-slot="{ errors }" rules="required">
            <v-text-field
              v-model="qualification.qualificationType"
              label="Qualification Type"
              :error-messages="getErrorMessages(errors)"
            />
          </ValidationProvider>
        </v-col>
        <v-col class="col-md-8 col-12 input-item">
          <ValidationProvider v-slot="{ errors }" rules="required">
            <v-text-field
              v-model="qualification.qualificationInstitution"
              :error-messages="getErrorMessages(errors)"
              label="Institution"
            />
          </ValidationProvider>
        </v-col>
        <v-col class="col-md-4 col-12 input-item">
          <ValidationProvider v-slot="{ errors }" rules="required">
            <v-text-field
              v-model="qualification.qualificationGrade"
              :error-messages="getErrorMessages(errors)"
              label="Grade"
            />
          </ValidationProvider>
        </v-col>
        <v-col class="col-md-6 col-12 input-item">
          <ValidationProvider v-slot="{ errors }" rules="required|validDate">
            <v-label>Date Started</v-label>
            <v-text-field
              type="text"
              placeholder="dd/mm/yyyy"
              v-mask="'##/##/####'"
              v-model="qualification.dateStarted"
              :error-messages="getErrorMessages(errors)"
              class="mt-2 pt-0"
            />
          </ValidationProvider>
        </v-col>
        <v-col class="col-md-6 col-12 input-item">
          <ValidationProvider
            v-slot="{ errors }"
            :rules="`required|validDate|afterDate:${qualification.dateStarted}`"
          >
            <v-label>Date Completed</v-label>
            <v-text-field
              type="text"
              placeholder="dd/mm/yyyy"
              v-mask="'##/##/####'"
              v-model="qualification.dateCompleted"
              :error-messages="getErrorMessages(errors)"
              class="mt-2 pt-0"
            />
          </ValidationProvider>
        </v-col>
      </v-row>
    </ValidationObserver>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { QUALIFICATIONS_NAMESPACE } from "@/store/modules/users/qualifications";
import { AUTH_NAMESPACE } from "@/store/modules/auth";
import { ADD_USER_QUALIFICATION } from "@/store/modules/users/qualifications/actions";
import { createNamespacedHelpers } from "vuex";
import { formatDate } from "@/utils/time";
import { BASE_DATE_FORMAT } from "@/constants/common";

const { mapState: mapAuthState } = createNamespacedHelpers(AUTH_NAMESPACE);
const { mapActions } = createNamespacedHelpers(QUALIFICATIONS_NAMESPACE);

const INITIAL_QUALIFICATION = {
  dateCompleted: "",
  qualificationGrade: "",
  qualificationInstitution: "",
  qualificationType: "",
  qualificationSubject: "",
  dateStarted: ""
};

export default {
  name: "NewQualifications",
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    initialData: Object
  },
  data() {
    return {
      showValidationErrors: false,
      qualification: { ...INITIAL_QUALIFICATION },
      isLoading: false
    };
  },
  created() {
    if (this.initialData) {
      this.qualification = {
        ...this.initialData,
        dateStarted: formatDate({
          date: this.initialData.dateStarted,
          endFormat: BASE_DATE_FORMAT
        }),
        dateCompleted: formatDate({
          date: this.initialData.dateCompleted,
          endFormat: BASE_DATE_FORMAT
        })
      };
    }
  },
  computed: {
    ...mapAuthState({
      self: state => state.userData
    })
  },
  methods: {
    ...mapActions({
      addUserQualification: ADD_USER_QUALIFICATION
    }),
    clearForm() {
      this.showValidationErrors = false;
      this.qualification = { ...INITIAL_QUALIFICATION };
    },
    getErrorMessages(errors) {
      return this.showValidationErrors ? errors : "";
    },
    async validate() {
      this.showValidationErrors = true;
      return this.$refs.qualificationDetailsForm.validate();
    },
    getData() {
      return this.qualification;
    }
  }
};
</script>

<style lang="scss">
.col {
  padding: 0px 15px 0 15px;
}
</style>
